var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxltyLogoSymbolInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "boxlty-logo-symbol",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.798,
    height: 32.736,
    viewBox: "0 0 28.798 32.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M136.809,315.163V334.33h10.672v-1.77h-8.906V315.928l12.61-11.907,12.658,11.86V332.56h-8.907v1.77h10.672V315.113l-14.427-13.52Z",
    transform: "translate(-136.809 -301.594)",
    fill: "#a2a2a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxltyLogoSymbolInactive);
export default __webpack_public_path__ + "static/media/boxlty-logo-symbol-inactive.234396176bd7055126d895494f6ba3d3.svg";
export { ForwardRef as ReactComponent };